/* Filter drop-down for the PTL Billing pages, in the shared FilterBar look (label above, "All …" shown as the value). */
import React from 'react'
import { MenuItem, TextField } from '@mui/material'
import { FieldLabel, FilterField } from '../../../common/FilterBar'

export default function FilterSelect({ label, value, onChange, allLabel = 'All', options = [], sx }) {
  return (
    <FilterField sx={sx}>
      <FieldLabel>{label}</FieldLabel>
      <TextField select size='small' fullWidth value={value ?? ''} onChange={(e) => onChange(e.target.value)} SelectProps={{ displayEmpty: true }}
        inputProps={{ 'aria-label': label }}>
        {allLabel != null && <MenuItem value=''>{allLabel}</MenuItem>}
        {options.map((o) => (typeof o === 'string'
          ? <MenuItem key={o} value={o}>{o}</MenuItem>
          : <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>))}
      </TextField>
    </FilterField>
  )
}

/** Any other filter input (client picker, AWB search) in the same labelled slot. */
export function FilterSlot({ label, children, sx }) {
  return (
    <FilterField sx={sx}>
      <FieldLabel>{label}</FieldLabel>
      {children}
    </FilterField>
  )
}
